import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { reduce, orderBy, map } from 'lodash';
import moment from 'moment';
import {
  stringComparator,
} from '../../../../components/table-cells/helpers';
import EmailRenderer from '../../../../components/table-cells/EmailRenderer';

import { getTablePreference } from '../../../App/AppReducer';
import {
  getUnlinkedContactLoaded as ceGetUnlinkedContactLoaded,
  getUnlinkedContactLoading as ceGetUnlinkedContactLoading,
  getUnlinkedContacts as ceGetUnlinkedContacts,
} from '../../CEReducer';

import {
  getUnlinkedContactLoaded as winLossGetUnlinkedContactLoaded,
  getUnlinkedContactLoading as winLossGetUnlinkedContactLoading,
  getUnlinkedContacts as winLossGetUnlinkedContacts,
} from '../../WinLossReducer';

import GodTable, { CUSTOM_FIELD_TYPES } from '../../../../components/god-table';


class UnlinkedContactTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onGridReady = this.onGridReady.bind(this);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getContactColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      comparator: stringComparator,
      valueGetter: (params) => {
        if (params && params.data) {
          return `${params.data.first_name} ${params.data.last_name}`;
        }
        return null;
      },
      cellRendererParams: {
        enableAutoHeight: true,
        column: {
          ...column,
        },
      },
    };
  }

  getPhoneColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      comparator: stringComparator,
      field: 'phone',
      cellRendererParams: {
        enableAutoHeight: true,
        column: {
          ...column,
        },
      },
    };
  }

  getOpportunityColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      comparator: stringComparator,
      field: 'opportunity.name',
      cellRendererParams: {
        enableAutoHeight: true,
        column: {
          ...column,
        },
      },
    };
  }

  getProductColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      comparator: stringComparator,
      valueGetter: (params) => {
        if (params && params.data) {
          return params.data.products ? map(params.data.products, 'label').join(', ') : '';
        }
        return null;
      },
      cellRendererParams: {
        enableAutoHeight: true,
        column: {
          ...column,
        },
      },
    };
  }

  getOwnerColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      comparator: stringComparator,
      valueGetter: (params) => {
        if (params && params.data) {
          return params.data.salespeople ? map(params.data.salespeople, 'name').join(', ') : '';
        }
        return null;
      },
      cellRendererParams: {
        enableAutoHeight: true,
        column: {
          ...column,
        },
      },
    };
  }

  getEmailColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      comparator: stringComparator,
      field: 'email',
      cellRenderer: 'emailRenderer',
      cellRendererParams: {
        enableAutoHeight: true,
        column: {
          ...column,
        },
      },
    };
  }

  getPublishDateColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'publish_date',
      sort: 'desc',
      type: 'dateColumn',
      cellRendererParams: {
        column,
      },
      valueGetter: (params) => {
        if (params && params.data) {
          return moment(params.data.publish_date).format('YYYY-MM-DD');
        }
        return null;
      },
      valueFormatter: (params) => {
        if (params.value) {
          const displayFormat = 'MMM DD, Y';
          return moment(`${params.value}`, 'YYYY-MM-DD').format(displayFormat);
        }
        return params.value;
      },
    };
  }
  

  getColDefs() {
    const { tableColumns } = this.props;
    const allColumns = reduce(orderBy(tableColumns, ['position'], ['asc']), (columns, tableColumn) => {
      let column = null;
      if (tableColumn.tag === 'contact') {
        column = this.getContactColumn(tableColumn);
      } else if (tableColumn.tag === 'phone') {
        column = this.getPhoneColumn(tableColumn);
      } else if (tableColumn.tag === 'opportunity') {
        column = this.getOpportunityColumn(tableColumn);
      } else if (tableColumn.tag === 'products') {
        column = this.getProductColumn(tableColumn);
      } else if (tableColumn.tag === 'publishDate') {
        column = this.getPublishDateColumn(tableColumn);
      } else if (tableColumn.tag === 'salespeople') {
        column = this.getOwnerColumn(tableColumn);
      } else if (tableColumn.tag === 'email') {
        column = this.getEmailColumn(tableColumn);
      }
      if (column) {
        columns.push(column);
      }
      return columns;
    }, []);
    return allColumns;
  }

  render() {
    const {
      contacts,
    } = this.props;
    const columnDefs = this.getColDefs();

    return (
      <div>
        <GodTable
          id={this.props.tableName}
          columnDefs={columnDefs}
          rowData={contacts}
          onGridReady={this.onGridReady}
          frameworkComponents={{
            emailRenderer: EmailRenderer,
            agTotalRowCountComponent: null,
          }}
          enableFullScreen
          tableManageConfigs={{
            enableCustomMeta: true,
            validCustomMetaObjects: ['Opportunity'],
          }}
          resourceType={GodTable.RESOURCE_TYPE.OPPORTUNITY}
          disableAddColumns
        />
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const { isWinLoss } = ownProps;
  const loading = isWinLoss ? winLossGetUnlinkedContactLoading(state) : ceGetUnlinkedContactLoading(state);
  const loaded = isWinLoss ? winLossGetUnlinkedContactLoaded(state) : ceGetUnlinkedContactLoaded(state);
  const contacts = isWinLoss ? winLossGetUnlinkedContacts(state) : ceGetUnlinkedContacts(state);
  return {
    tableColumns: getTablePreference(state, ownProps.tableName),
    loading: !loaded || loading,
    contacts,
  };
}

UnlinkedContactTable.propTypes = {
  isWinLoss: PropTypes.bool,
  tableName: PropTypes.string.isRequired,
  contacts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  tableColumns: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string.isRequired,
    description: PropTypes.string,
    is_system: PropTypes.bool,
    is_visible: PropTypes.bool,
    position: PropTypes.number,
    width: PropTypes.number,
    tag: PropTypes.string,
    label: PropTypes.string,
    target_object: PropTypes.string,
    target_field: PropTypes.string,
  })),
  loading: PropTypes.bool,
};
UnlinkedContactTable.defaultProps = {
  tableColumns: [],
  loading: false,
  isWinLoss: false,
};
UnlinkedContactTable.contextTypes = {
};


export default connect(mapStateToProps)(UnlinkedContactTable);
